import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-gatorz-compare-image.js';

const DEFAULT_IMAGE_LEFT = 'https://cdn.skyfastimg.com/images/2026/06/10/image-6a290e8e40330e421af4b1bf.webp?w=1000';
const DEFAULT_IMAGE_RIGHT = 'https://cdn.skyfastimg.com/images/2026/06/10/image-6a290e71ab5b38e642ca0de3.webp?w=1000';

const html = `
<div class="gatorz-compare-image-content" data-attribute="gatorz-compare-image-content">
  <div class="container">
    <div class="gatorz-compare-image__header" data-attribute="gatorz-compare-image__header">
      <p style="text-align: center;">SLIDE TO VIEW</p>
      <h2 style="text-align:center;"><span style="font-size:44px;"><strong>TRU-RAY OPZ POLARIZATION</strong></span></h2>
    </div>
    <div class="gatorz-compare-image__body" data-attribute="gatorz-compare-image__body">
      <div class="img-comp-container" data-attribute="gatorz-compare-image__slider" data-initial-percent="50">
        <div class="img-comp-img">
          <img
            loading="lazy"
            data-attribute="gatorz-compare-image__image-right"
            src="${DEFAULT_IMAGE_RIGHT}"
            alt=""
          />
        </div>
        <div class="img-comp-slider"></div>
        <div class="img-comp-img img-comp-overlay">
          <img
            loading="lazy"
            data-attribute="gatorz-compare-image__image-left"
            src="${DEFAULT_IMAGE_LEFT}"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  topPadding: true,
  bottomPadding: true,
});
